import moment from "moment";
import StatusCustom from "../../../../components/status/statusCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";
import { dateTimeToView } from "../../../../utils/date.utils";
import OptionsButtonCustom from "../../../../components/option-button/OptionsButtonCustom";
import { OnlineCourseApi, onlineCourseTag, onlineCourseTagList } from "../../../../api/online-corse/online_course.api";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, unsetLoading } from "../../../../store/loading/loading.slice";
import { alertActive, alertError, alertSuccess } from "../../../../components/alert/swal";
import SwitchCustom from "../../../../components/switch/SwitchCustom";
import { GalleryApi, galleryListType } from "../../../../api/gallery/gallery.api";
import { GALLERY_CATEGORY } from "../enum";
import { useNavigate } from "react-router-dom";
import { routeName } from "../../../../routes/routeName";
import { STATUS_DATA } from "../../../../constants";
import { RootState } from "../../../../store/store";
import { checkPermission } from "../../../../utils/app.utils";


export const ManageState = () => {
    const { t } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const profileReducer = useSelector((state: RootState) => state.profile.profile);
    const permission: any[] = profileReducer?.permission || [];
    const checkPermit = checkPermission('WEBSITE_STRUCTURE_GALLERY_VIDEO', permission);

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC");
    const [data, setData] = useState<any[]>([]);
    const [showModal, setShowModal] = useState<string>("");
    const [keyword, setKeyword] = useState<string>("");
    const [gallery_type_data, set_gallery_type_data] = useState<any[]>([]);
    const [date_range, set_date_range] = useState<{ start_date: string | null, end_date: string | null }>({
        end_date: "",
        start_date: ""
    });
    const [id_gallery_type, set_id_gallery_type] = useState<any>(null);

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }
    const handleCloseModal = () => {
        setShowModal("");
    }

    const handleChangeDateRange = (st: string | null, end: string | null) => {
        set_date_range({ start_date: st, end_date: end })
    }
    const headCells = [
        {
            id: "subject_no", width: 60, sortable: false, disablePadding: false, align: 'center', label: t("COMPLAINTS_ORDER")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "left", label: "ชื่อ"
        },
        {
            id: "group", disablePadding: false, width: 140, align: "center", label: "หมวดหมู่"
        },
        {
            id: "status", disablePadding: false, width: 50, align: "center", label: "สถานะ"
        },
        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: "ผู้ที่สร้าง/ปรับปรุงล่าสุด"
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: "วันที่สร้าง/ปรับปรุงล่าสุด"
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 100, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            created_date,
            modified_date,
            created_by,
            gallery_type_name,
            gallery_name,
            id_gallery,
            is_public,
            modified_by
        } =
            objData;

        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: gallery_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: gallery_type_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: <div className="flex justify-center items-center">
                        <SwitchCustom disabled={!id_gallery} checked={!!is_public} onChange={(st) => handleUpdateIsPublic(id_gallery, st)} /></div>
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_by || created_by || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateTimeToView(modified_date) : created_date ? dateTimeToView(created_date) : "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        <OptionsButtonCustom
                            enableEdit={checkPermit.isUpdate}
                            enableView={checkPermit.isView}
                            enableDelete={checkPermit.isDelete}
                            onViewClick={() => {
                                navigate(routeName.cms_website.collection_vdo_view.replace(":id", id_gallery))
                            }}
                            onEditClick={() => {
                                navigate(routeName.cms_website.collection_vdo_detail.replace(":id", id_gallery))
                            }}
                            onDeleteClick={() => handleDelete(id_gallery)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };


    const handleDelete = (id_gallery: number) => {
        alertActive("ลบรายการ", "ท่านต้องการลบรายการนี้?", undefined, undefined, async () => {
            dispatch(setLoading());
            await GalleryApi.delete(id_gallery).then((res) => {
                if (res.status < 300) {
                    alertSuccess("ลบรายการ", "ลบรายการ เรียบร้อยแล้ว");
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError("ลบรายการ", "ลบรายการ เรียบร้อยแล้ว")
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }


    const handleGetGalleryTypeData = async () => {
        await GalleryApi.findDropdownType().then((res) => {
            if (res.status < 300) {
                const data_value = res.data?.data || [];
                set_gallery_type_data(data_value)
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const handleUpdateIsPublic = async (id_gallery: number, is_public: boolean) => {
        await GalleryApi.update_status(id_gallery, {
            is_public
        }).then((res) => {
            if (res.status < 300) {
                handleGetData();
            }
        }).catch((err) => {
            alertError("อัพเดตข้อมูลไม่สำเร็จ")
            console.log(err)
        })
    }

    const handleGetData = useCallback(async () => {
        let query: galleryListType = {
            page: page,
            limit: pageLimit,
            type: GALLERY_CATEGORY.VIDEO
        }
        dispatch(setLoading());
        if (keyword) query = { ...query, search: keyword }
        if (date_range.start_date) query = { ...query, start_date: moment(date_range.start_date).format("YYYY-MM-DD") }
        if (date_range.end_date) query = { ...query, end_date: moment(date_range.end_date).format("YYYY-MM-DD") }
        if (id_gallery_type) {
            query.id_gallery_type = id_gallery_type?.id_gallery_type
        }
        await GalleryApi.list(query).then((res) => {
            if (res.status < 300) {
                const data_item = res.data?.data?.items || [];
                const total_item = res.data?.data?.meta?.totalItems || [];
                setData(data_item);
                setTotalItems(total_item)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, sortBy, sortType, date_range.end_date, date_range.start_date, keyword, id_gallery_type])


    useEffect(() => {
        handleGetGalleryTypeData()
    }, [])
    useEffect(() => {
        handleGetData()
    }, [handleGetData])

    return {
        page,
        pageLimit,
        data,
        sortBy,
        sortType,
        handleRequestSort,
        setPage,
        setPageLimit,
        headCells,
        totalItems,
        renderData,
        handleCloseModal,
        showModal,
        setShowModal,
        // handleSubmit,
        setKeyword,
        handleChangeDateRange,
        date_range,
        gallery_type_data,
        set_id_gallery_type,
        id_gallery_type,
        checkPermit
    }
}